var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSearchResults } from "@/hooks/useSearchResults";
import { Center, Text } from "@chakra-ui/react";
import { TwoPane } from "@/components/cortex";
export var SearchResultsView = function (_a) {
    var loading = _a.loading, error = _a.error, searchData = _a.searchData;
    var getMessage = function () {
        switch (true) {
            case !!error:
                return "Error occurred. Try again later";
            case loading:
                return "Loading...";
            case !(searchData === null || searchData === void 0 ? void 0 : searchData.jobs.length):
                return "No jobs right now, check back soon!";
            default:
                return "";
        }
    };
    var message = getMessage();
    // The live region stays mounted, so screen readers register it on load and
    // announce every message change.
    return (_jsxs(_Fragment, { children: [_jsx(Center, __assign({ role: "status" }, { children: _jsx(Text, __assign({ variant: "searchResultsWarning" }, { children: message })) })), searchData && _jsx(TwoPane, { searchData: searchData })] }));
};
export var SearchResults = function () { return (_jsx(SearchResultsView, __assign({}, useSearchResults()))); };
